<template>
  <div>
    <mainTran v-if="boolUser" :data_new="data" :boolUser_new="boolUser">
    </mainTran>
  </div>
</template>
<script>
import mainTran from "./main.vue";
import api from "@/mixins/api";
import helper from "@/mixins/helper";
export default {
  components: { mainTran },
  data() {
    return {
      data: [],
      boolUser: false
    };
  },
  methods: {
    loadDetail() {
      this.api("admin/user?user=" + this.$route.params.id).then(res => {
        this.data = res;
        this.boolUser = true;
      });
    }
  },
  mounted() {
    this.loadDetail();
  },
  mixins: [api, helper]
};
</script>
<style scoped></style>
